<template>
  <FormInput :label-for="labelFor" :label-text="labelText"
             :show-error="showError" :error-text="errorText"
             :required="required" :smallInput="smallInput"
             isCheckbox
  >
    <input @change="updateInput" v-model="value"
           :id="labelFor" type="checkbox"
           :class="{ 'error': hasError }">
  </FormInput>
</template>
<script>
import FormInput from "./FormInput.vue";

export default {
  components: {FormInput},
  props: {
    labelFor: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: true,
    },
    inputValue: {
      required: true,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    smallInput: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['change'],
  data() {
    return {
      value: this.inputValue,
      isCheckbox: true,
    }
  },
  computed: {
    hasError() {
      return this.showError && this.errorText.length > 0;
    }
  },
  methods: {
    updateInput() {
      this.$emit('change', {value: this.value});
    }
  }
}
</script>
<style scoped>
input {
  max-width: 20px;
  max-height: 20px;
  color: #C9C9CC;
  accent-color: var(--brown);
}
</style>